/**
 * Copyright(C) 2009-2011, 2018, xplo.re IT Services, Michael Maier.
 * All rights reserved.
 */

(function (application) {
    "use strict";

    application.extendWith({

        bindDisplay: function (node, target, values, negate, x, o) {
            node = $(node);
            target = $(target);

            var nodeValue = node.val();

            if (negate && null != values && values.indexOf(nodeValue) < 0
                || negate && null == values && !nodeValue
                || !negate && null != values && values.indexOf(nodeValue) >= 0
                || !negate && null == values && nodeValue) {
                if (x) {
                    $(target).show();
                }
                else {
                    window.setTimeout(
                        function () {
                            target.fadeIn(500);
                        },
                        350
                    );
                }
            }
            else {
                if (x) {
                    $(target).hide();
                }
                else if (!o) {
                    target.fadeOut(300);
                }
            }
        }

    });

}(application));